interface Position {
  x: number
  y: number
}

/**
 * 创建抛物线动画
 * @param startEl 起始元素
 * @param endEl 目标元素
 * @param options 配置选项
 */
export function parabolicBall(
  startEl: HTMLElement,
  endEl: HTMLElement,
  options: {
    /** 动画时长(ms) */
    duration?: number
    /** 小球大小(px) */
    ballSize?: number
    /** 小球颜色 */
    ballColor?: string
    /** 动画完成回调 */
    onComplete?: () => void
  } = {},
) {
  const {
    duration = 800,
    ballSize = 10,
    ballColor = '#1890ff',
    onComplete,
  } = options

  // 获取起始点和终点的位置
  const startRect = startEl.getBoundingClientRect()
  const endRect = endEl.getBoundingClientRect()

  const start: Position = {
    x: startRect.left + startRect.width / 2,
    y: startRect.top + startRect.height / 2,
  }

  const end: Position = {
    x: endRect.left + endRect.width / 2,
    y: endRect.top + endRect.height / 2,
  }

  // 创建小球元素
  const ball = document.createElement('div')
  ball.style.cssText = `
    position: fixed;
    left: ${start.x - ballSize / 2}px;
    top: ${start.y - ballSize / 2}px;
    width: ${ballSize}px;
    height: ${ballSize}px;
    background-color: ${ballColor};
    border-radius: 50%;
    z-index: 999999;
    pointer-events: none;
  `
  document.body.appendChild(ball)

  // 设置动画
  const distance = {
    x: end.x - start.x,
    y: end.y - start.y,
  }

  // 设置贝塞尔曲线控制点
  const controlPoint = {
    x: start.x + distance.x / 2,
    y: start.y - Math.abs(distance.x / 3), // 控制抛物线的高度
  }

  // 动画开始时间
  const startTime = Date.now()

  function animate() {
    const currentTime = Date.now()
    const progress = Math.min(1, (currentTime - startTime) / duration)

    if (progress < 1) {
      // 二次贝塞尔曲线计算位置
      const currentX = start.x + distance.x * progress
      const currentY = start.y + distance.y * progress
        - Math.sin(progress * Math.PI) * Math.abs(distance.y) // 使用正弦函数创建抛物线效果

      ball.style.transform = `translate(${currentX - start.x}px, ${currentY - start.y}px)`
      requestAnimationFrame(animate)
    }
    else {
      // 动画结束，移除小球
      document.body.removeChild(ball)
      onComplete?.()
    }
  }

  requestAnimationFrame(animate)
}
